import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

var LLSelectField = /*#__PURE__*/function (_Component) {
  _inherits(LLSelectField, _Component);

  var _super = _createSuper(LLSelectField);

  function LLSelectField() {
    _classCallCheck(this, LLSelectField);

    return _super.apply(this, arguments);
  }

  _createClass(LLSelectField, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectField, {
        autoWidth: this.props.autoWidth,
        fullWidth: this.props.fullWidth,
        id: this.props.id,
        onChange: this.props.onChange,
        style: this.props.style,
        value: this.props.value
      }, this.props.children));
    }
  }]);

  return LLSelectField;
}(Component);

_defineProperty(LLSelectField, "propTypes", {
  autoWidth: PropTypes.bool,
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  multiple: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  value: PropTypes.any
});

_defineProperty(LLSelectField, "defaultProps", {
  autoWidth: false,
  fullWidth: true,
  id: null,
  onChange: null,
  style: {},
  value: ''
});

export { LLSelectField as default };